import React from "react";
import { Helmet } from "react-helmet";
import { legal } from "../data/legal";

// Per-route meta + Organization JSON-LD. We are a migration support and
// coordination service, not a registered migration agent, so no MARN is
// emitted for us (repositioning, D-003 under revision).
// `noindex` is opt-in per page (D-012). The site is indexable by default; this
// exists so unbuilt stubs and the catch-all route stay out of search results.
export default function SEO({ title, description, path = "/", noindex = false }) {
  const fullTitle = title
    ? `${title} | ${legal.brandName}`
    : `${legal.brandName}, ${legal.tagline}`;
  const canonical = `${legal.siteUrl}${path}`;

  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: legal.brandName,
    url: legal.siteUrl,
    description: legal.tagline,
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
    </Helmet>
  );
}
